
import eventBus         from 'EventBus.js';
import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'common-inputs/control_time_input.ejs';
//=====================================================================
//
// An instance of this view represents a time input control.
//
// Alfonso Cabral, February, 4 2016
//
//=====================================================================
class TimeInputControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-time-input';

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'TimeInputControlView';
    }


}

export default TimeInputControlView;
